import React from "react";
import { Link, useHistory } from "react-router-dom";
import { PageSettings } from "./../config/page-settings.js";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";

class LoginV3 extends React.Component {
  static contextType = PageSettings;

  state = {
    email: "",
    password: "",
    error: "",
    type: "password",
  };

  constructor(props) {
    super(props);

    this.showHide = this.showHide.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem("sesion");
    localStorage.removeItem("user");
    localStorage.removeItem("grupos");
    localStorage.removeItem("nivel_actual");
    localStorage.removeItem("nivel_name");
    localStorage.removeItem("accesos");
    localStorage.removeItem("token");

    this.context.handleSetPageSidebar(false);
    this.context.handleSetPageHeader(false);
    this.context.handleSetBodyWhiteBg(false);
    Api.loading(true);
    Api.loadCatalogues();
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.auth
      .login(this.state)
      .then((response) => {
        if (response) {
          this.handleLogin();
          localStorage.setItem("expirado", "0");
        }
      })
      .catch((error) => {
        localStorage.removeItem("token");

        error.json().then((message) => {
          if (message.email != null) {
            this.setState({
              error: "Introduzca una dirección de correo electrónico válida.",
            });
          } else if (message.password != null) {
            this.setState({
              error: "La contraseña debe contener al menos 6 caracteres.",
            });
          } else {
            this.setState({
              error: "Correo electrónico o contraseña incorrectos.",
            });
          }
        }); //catching errors to show notification
      });
  }

  showHide(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      type: this.state.type === "input" ? "password" : "input",
    });
  }

  handleLogin() {
    this.props.auth.profile().then((response) => {
      Api.loading(0);
      if (response.email_verified_at == null) {
        localStorage.sesion = JSON.stringify(response);
        this.props.history.push("/confirm");
      } else {
        Api.loadCatalogues();
        let grupos = JSON.parse(localStorage.grupos);
        if (grupos.length > 1) {
          this.props.history.push("/seleccionar-nivel");
        } else {
          localStorage.nivel_actual = grupos[0].id;
          localStorage.nivel_name = grupos[0].description;
          this.props.history.push("/");
        }
      }
    });
  }

  render() {
    return (
      <div className="login login-with-news-feed">
        <div className="news-feed">
          <div
            className="news-image"
            style={{
              backgroundImage: "url('../assets/pulpa_pellets_cabecera.jpg')",
            }}
          ></div>
          <div className="news-caption">
            <h4 className="caption-title">
              Sistema Integral Nacional de Insumos Pecuarios
            </h4>
            <p></p>
          </div>
        </div>
        <div className="right-content">
          <div className="login-header">
            <div className="brand">
              {/* <span className="navbar-logo"></span> */}
              {/* <img class="logo" src="../favicon.ico" ></img> <b>SINAIP</b> */}
              <h1>Inicio de sesión</h1>
            </div>
            <div className="icon">
              <i className="fa fa-sign-in"></i>
            </div>
          </div>
          <div className="login-content">
            <form
              className="margin-bottom-0"
              id="frmLogin"
              onSubmit={this.handleSubmit}
            >
              <div className="form-group m-b-15">
                <input
                  type="text"
                  name="email"
                  value={this.state.email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  className="form-control form-control-lg"
                  placeholder="Correo electrónico"
                  maxLength="255"
                  required
                />
              </div>

              <div className="row row-space-10">
                <div className="col-md-11 m-b-15">
                  <input
                    type={this.state.type}
                    name="password"
                    value={this.state.password}
                    onChange={(e) =>
                      this.setState({ password: e.target.value })
                    }
                    className="form-control form-control-lg"
                    placeholder="Contraseña"
                    maxLength="255"
                    required
                  />
                </div>
                <div
                  className="col-md-1 m-b-15"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <button
                    type="button"
                    className="btn btn-sm"
                    onClick={this.showHide}
                  >
                    {this.state.type === "input" ? (
                      <i className="fa fa-eye-slash"></i>
                    ) : (
                      <i className="fa fa-eye"></i>
                    )}
                  </button>
                </div>
              </div>

              <div className="form-group m-b-15">
                <span style={{ color: "red" }}>{this.state.error}</span>
              </div>

              {/* <div className="checkbox checkbox-css m-b-30">
                <input type="checkbox" id="remember_me_checkbox" value="" />
                <label htmlFor="remember_me_checkbox">Recuerdame</label>
              </div> */}
              <div className="login-buttons">
                <button type="submit" className="btn btn-teal btn-block btn-lg">
                  Iniciar sesión
                </button>
              </div>
              <div className="m-t-20 m-b-10 p-b-10 text-center">
                <Link to="/password-request" className="text-teal">
                  <u>¿Olvidaste tu contraseña?</u>
                </Link>
              </div>

              <hr />

              <div
                className="m-t-10 m-b-10 p-b-10 text-center"
                style={{ fontSize: "0.9rem" }}
              >
                ¿No tienes una cuenta?{" "}
                <Link to="/register" className="text-teal">
                  <b>Registrarse</b>
                </Link>
              </div>

              <p className="text-center text-grey-darker">
                By <b>ASEENTI</b>
              </p>

              <div className="m-t-10 m-b-10 p-b-10 text-right">
                <Link to="/denuncias-publicas" className="text-teal">
                  <u>Denuncias públicas</u>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

//export default withRouter(LoginV3);
export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <LoginV3 auth={auth} history={history} {...props} />;
};
